import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import LoadingSpinner from "@app/shared/LoadingSpinner";
import AuthenticationService from "@app/authentication/authenticationService";

interface SilentRefreshCallbackState {
  foo: string;
}

type SilentRefreshCallbackProps = RouteComponentProps;

class SilentRefreshCallback extends React.Component<SilentRefreshCallbackProps, SilentRefreshCallbackState> {

  constructor(props: SilentRefreshCallbackProps) {
    super(props);
  }

  public async componentDidMount() {
    try {
      await AuthenticationService.getInstance().signInCallback();
    } catch (e) {
      throw e;
    }
  }

  public render() {
    return (
      <>
        <div className="pt-3 ps-3">
          <LoadingSpinner />
        </div>
      </>
    );
  }

}

export default SilentRefreshCallback as React.ComponentClass<SilentRefreshCallbackProps>;
